import { cn } from "core/shared";
import { price } from "~/modules/shared/utils";

type PriceProps = {
  originalPrice: number;
  salePrice?: number;
  classes?: {
    container?: string;
    price?: string;
    salePrice?: string;
  };
};

const DEFAULT_PRICE_CLASSES = "text-primary-default text-2xl font-extrabold";
const DEFAULT_ORIGINAL_PRICE_CLASSES =
  "text-dirt-default text-sm font-semibold line-through";

export function Price({ originalPrice, salePrice, classes }: PriceProps) {
  const hasSale =
    salePrice !== undefined && salePrice > 0 && salePrice < originalPrice;

  return (
    <div
      className={cn(
        "font-avenir flex items-center gap-2 text-2xl font-extrabold",
        classes?.container,
      )}
    >
      {hasSale ? (
        <>
          <span
            className={cn(DEFAULT_PRICE_CLASSES, classes?.salePrice)}
            aria-label={`Sale price: ${price(salePrice)}`}
          >
            {price(salePrice)}
          </span>
          <del
            className={cn(DEFAULT_ORIGINAL_PRICE_CLASSES, classes?.price)}
            aria-label={`Original price: ${price(originalPrice)}`}
          >
            {price(originalPrice)}
          </del>
        </>
      ) : (
        <span
          className={cn(DEFAULT_PRICE_CLASSES, classes?.price)}
          aria-label={`Price: ${price(originalPrice)}`}
        >
          {price(originalPrice)}
        </span>
      )}
    </div>
  );
}
